import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import QuickInfoCardCommon from "../QuickInfoCardCommon";

import PopupWrapper from "../PopupWrapper";
import PorfolioAtGlanceIndependent from "./IndependentPorfolioAtGlance";
// import UpcomingPaymentsIndependent from "./IndependentUpcomingPayments";
import ErrorBoundary from "../../components/ErrorBoundary";
// import { fetchKpis } from "../../store/reducers/dashboardSlice/api";
import DoughnutAndMeter from "../DoughnutAndMeter";
import LoanChargesTables from "../AllTables/LoanChargesTables";
import UpcomingPaymentsTable from "../AllTables/UpcomingPaymentsTable";
import {
  fetchKpis,
  fetchLoanCharges,
} from "../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

const CommonTopsection = () => {
  const dispatch = useDispatch();
  const { signal } = useAbortController();
  const [PortfolioAtGlancePopupShow, setPortfolioAtGlancePopupShow] =
    useState(false);
  const [UpcomingPaymentsPopupShow, setUpcomingPaymentsPopupShow] =
    useState(false);
  const [LoanChargesPopupShow, setLoanChargesPopupShow] = useState(false);

  const lenderId = useSelector((state) => state.account.lenderId);
  const kpis = useSelector((state) => state.dashboard.kpis);
  // const status = useSelector((state) => state.dashboard.kpis.status);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const status = useSelector(
    (state) => state.dashboard?.["loanCharges"]?.status
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchKpis({ lenderId, role: selectedRole, signal }));
    }
  }, [dispatch, lenderId, status]);

  // useEffect(() => {
  //   if (selectedRole === "V" && status === "idle") {
  //     dispatch(fetchLoanCharges({ lenderId, signal }));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dispatch, lenderId, status, selectedRole]);

  return (
    <div className="row p-3 pt-0 pb-0 d-flex" style={{ minHeight: "345px" }}>
      <div
        className="col-xl-7 col-lg-12 py-0 gx-0 portfolio-balance-upcoming-payments d-flex flex-column"
        style={{ paddingRight: "8px" }}
      >
        <div className="row flex-1">
          <button
            onClick={() => {
              setPortfolioAtGlancePopupShow(true);
            }}
            className="col-xl-6 col-lg-6"
            style={{ border: "none" }}
          >
            <QuickInfoCardCommon
              class_name="pb-3 h-100 bg-white rounded"
              label={
                selectedRole === "V"
                  ? "Active Loan Portfolio Balance"
                  : "Portfolio Balance"
              }
              // info={
              //   kpis.portfolioBalanceStatus === "fulfilled"
              //     ? kpis.portfolioBalance
              //     : "-"
              // }
              info={
                kpis.status === "fulfilled"
                  ? kpis.portfolioBalance
                  : "-"
              }
            />
          </button>
          <button
            onClick={() => {
              setUpcomingPaymentsPopupShow(true);
            }}
            className="col-xl-6 col-lg-6"
            style={{ border: "none" }}
          >
            <QuickInfoCardCommon
              class_name="pb-3 h-100 bg-white rounded"
              label="Upcoming Payments"
              // info={
              //   kpis.upcomingPaymentsStatus === "fulfilled"
              //     ? kpis.upcomingPayments
              //     : "-"
              // }
              info={
                kpis.status === "fulfilled"
                  ? kpis.upcomingPayments
                  : "-"
              }
            />
          </button>
        </div>
        <div className="row flex-1">
          <QuickInfoCardCommon
            // class_name={`col-xl-${selectedRole === "V" ? 12 : 6} col-lg-${
            //   selectedRole === "V" ? 12 : 6
            // } pt-3`}
            class_name={`col-xl-6 col-lg-6 pt-3`}
            label="Total No. of Loans"
            // info={kpis.loanCountStatus === "fulfilled" ? kpis.loanCount : "-"}
            info={kpis.status === "fulfilled" ? kpis.loanCount : "-"}
          />
          {/* {selectedRole === "L" && ( */}
          <button
            onClick={() => {
              setLoanChargesPopupShow(true);
            }}
            className="col-xl-6 col-lg-6 pt-3"
            style={{ border: "none" }}
          >
            <QuickInfoCardCommon
              class_name="col-xl-12 col-lg-12 pt-3 h-100 bg-white rounded"
              label="Outstanding Charges"
              // info={
              //   kpis.outstandingChargesStatus === "fulfilled"
              //     ? kpis?.outstandingCharges || 0
              //     : "-"
              // }
              info={
                kpis.status === "fulfilled"
                  ? kpis?.outstandingCharges || 0
                  : "-"
              }
            />
          </button>
          {/* )} */}
        </div>
      </div>
      <ErrorBoundary className="col-xl-5 col-lg-12 py-3 px-3 loan-aging">
        <DoughnutAndMeter />
      </ErrorBoundary>

      <ErrorBoundary>
        <PopupWrapper
          Component={
            <ErrorBoundary>
              <PorfolioAtGlanceIndependent />
            </ErrorBoundary>
          }
          title="Portfolio At Glance Pie Chart"
          toShow={PortfolioAtGlancePopupShow}
          closeEventHandler={() => {
            setPortfolioAtGlancePopupShow(false);
          }}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <PopupWrapper
          // Component={<UpcomingPaymentsIndependent />}
          Component={
            <UpcomingPaymentsTable
              className={"col-sm-12"}
              footer={false}
              viewAllModal={false}
            />
          }
          toShow={UpcomingPaymentsPopupShow}
          // title="Upcoming Payments Bar Chart"
          title="Upcoming Payments Table"
          closeEventHandler={() => {
            setUpcomingPaymentsPopupShow(false);
          }}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <PopupWrapper
          Component={
            <LoanChargesTables
              className={"col-sm-12"}
              footer={false}
              viewAllModal={false}
            />
          }
          toShow={LoanChargesPopupShow}
          title="Loan Charges"
          closeEventHandler={() => {
            setLoanChargesPopupShow(false);
          }}
        />
      </ErrorBoundary>
    </div>
  );
};
export default CommonTopsection;
